import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/client';
import { Button, Input, Card, CardBody } from '../../components/ui';
import { ArrowLeft } from 'lucide-react';
export function ForgotPasswordPage() {
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm();
    const onSubmit = async (data) => {
        setLoading(true);
        setError('');
        const { error } = await authApi.forgotPassword(data.email);
        setLoading(false);
        if (error) {
            setError(error);
            return;
        }
        setSuccess(true);
    };
    return (<div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">S</span>
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          Reset your password
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card>
          <CardBody>
            {success ? (<div className="text-center">
                <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/>
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">Check your email</h3>
                <p className="text-gray-600 mb-4">
                  If an account with that email exists, we've sent a password reset link.
                </p>
                <Link to="/login" className="text-primary-600 hover:text-primary-500 font-medium">
                  Back to sign in
                </Link>
              </div>) : (<form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                {error && (<div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
                    {error}
                  </div>)}

                <Input label="Email address" type="email" {...register('email', {
            required: 'Email is required',
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
            },
        })} error={errors.email?.message}/>

                <Button type="submit" className="w-full" loading={loading}>
                  Send reset link
                </Button>

                <div className="text-center">
                  <Link to="/login" className="inline-flex items-center text-sm text-gray-600 hover:text-primary-600">
                    <ArrowLeft className="w-4 h-4 mr-1"/>
                    Back to sign in
                  </Link>
                </div>
              </form>)}
          </CardBody>
        </Card>
      </div>
    </div>);
}
